import React, { useEffect } from 'react';
import {
  Form,
  FormInstance,
  SelectBooleanInput,
  NumberInput
} from 'blueprint-form';
import { Row, Col } from '../../../../grid';
import { CardBlock } from '../../../organisms/card';

interface EpxDiabetesSettingsData {
  alerts: boolean;
  afterHourInfo: boolean;
  postprandialAlert: boolean;
  thresholds: {
    red: {
      fasting: {
        avg: number;
        max: number;
        min: number;
      };
    };
    yellow: {
      fasting: {
        avg: number;
      };
    };
    highTwoWeekAvgCount: number;
  };
}

const DefaultSettings: EpxDiabetesSettingsData = {
  alerts: true,
  afterHourInfo: false,
  postprandialAlert: false,
  thresholds: {
    red: {
      fasting: {
        avg: 200,
        max: 400,
        min: 70
      }
    },
    yellow: {
      fasting: {
        avg: 130
      }
    },
    highTwoWeekAvgCount: 4
  }
};

interface EpxDiabetesSettingsProps {
  setForm?: (form: FormInstance<EpxDiabetesSettingsData>) => void;
  onSubmit?: (data: EpxDiabetesSettingsData) => void;
  disabled?: boolean;
}

const EpxDiabetesSettings = ({
  setForm,
  onSubmit,
  disabled
}: EpxDiabetesSettingsProps): JSX.Element => {
  const form = new FormInstance<EpxDiabetesSettingsData>(DefaultSettings);
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  return (
    <CardBlock bare>
      <Form form={form} onSubmit={onSubmit}>
        <CardBlock>
          <Row>
            <Col sm={12}>
              <SelectBooleanInput
                label="Enable Alerts for Patient"
                name="alerts"
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <SelectBooleanInput
                label="Inform Business Hour"
                name="afterHourInfo"
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <SelectBooleanInput
                label="Postprandial Alert"
                name="postprandialAlert"
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <NumberInput
                label="Red - Fasting Max"
                name="thresholds.red.fasting.max"
                required
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <NumberInput
                label="Red - Fasting Min"
                name="thresholds.red.fasting.min"
                required
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <NumberInput
                label="Red - Fasting Avg"
                name="thresholds.red.fasting.avg"
                required
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <NumberInput
                label="Yellow - Fasting Avg"
                name="thresholds.yellow.fasting.avg"
                required
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <NumberInput
                label="Value Count for High 2-Week Average Alert"
                name="thresholds.highTwoWeekAvgCount"
                required
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
        </CardBlock>
      </Form>
    </CardBlock>
  );
};

export default EpxDiabetesSettings;
